import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import fr from './i18n/fr.js'
import en from './i18n/en.js'

const i18n = new VueI18n({
  locale: 'fr', // locale initiale
  fallbackLocale: 'fr', // locale si inconnue
  messages: {
    en: fr,
    fr: fr,
  }
})

export default i18n
